{
    "reset": "Rensa filter",
    "apply": "Applicera"
}
